import {
  OTA_IDS,
  type OtaId,
} from 'frontend-utils/utils/constants/constant-values';
import type { RestrictionType } from 'lumen/utils/constants/restriction-actions';

export const NB_OF_DAYS_SHOWN_ON_PAGE = 7;

export const PMS_TABLE_ROW_TYPES = {
  RESTRICTION: 'restrictions',
  PRICING_PARENT_ROW: 'pricing_parent_row',
  PRICING_CHILD_ROW: 'pricing_child_row',
} as const;

export const CHANNELS_TABLE_ROW_TYPES = {
  RESTRICTION: 'restrictions',
  PRICING_PARENT_ROW: 'pricing_parent_row',
  PRICING_CHILD_ROW: 'pricing_child_row',
} as const;

export const MINOR_CHANNELS_TABLE_ROW_TYPES = {
  RESTRICTION: 'restrictions',
  MINOR_CHANNEL: 'minor_channel',
} as const;

export const RESTRICTION_MODEL_CONTEXTS = {
  HOTEL_LEVEL: 'HOTEL_LEVEL',
  ROOM_LEVEL: 'ROOM_LEVEL',
  RATE_PLAN_LEVEL: 'RATE_PLAN_LEVEL',
  RATE_GROUP_LEVEL: 'RATE_GROUP_LEVEL',
  CHANNEL_LEVEL: 'CHANNEL_LEVEL',
  ROOM_RATE_PLAN_LEVEL: 'ROOM_RATE_PLAN_LEVEL',
} as const;

export type RestrictionModelContextsType =
  (typeof RESTRICTION_MODEL_CONTEXTS)[keyof typeof RESTRICTION_MODEL_CONTEXTS];

export const RESTRICTION_TYPES = {
  CLOSED: 'CLOSED',
  OVERBOOKING: 'OVERBOOKING',
  MIN_LOS: 'MIN_LOS',
} as const;

// Restriction types channel pricing can act on. Overbooking is deliberately
// excluded: channel pricing has no overbooking concept, so overbooking-only
// actions must not affect its restriction-failure state (COA-4070).
export const CHANNEL_PRICING_HOTEL_RESTRICTION_TYPES: readonly RestrictionType[] =
  [RESTRICTION_TYPES.MIN_LOS, RESTRICTION_TYPES.CLOSED];

// FE only "type" -> not used in BE because it basically means that no restriction is returned
export const RESTRICTION_TYPE_NONE = 'NONE';

export const RESTRICTION_MINOR_CHANNEL_ID = 'OTHER' as const;

export const RESTRICTION_API_MESSAGE_VALUES = {
  INCONSISTENT_HOTEL_RESTRICTION: 'INCONSISTENT_HOTEL_RESTRICTION',
  RESTRICTION_NOT_PRESENT_ON_LEADING_ROOM_BASE_RATE:
    'RESTRICTION_NOT_PRESENT_ON_LEADING_ROOM_BASE_RATE',
} as const;

export type RestrictionEditOption = {
  id: string;
  label: string;
  type: RestrictionType | typeof RESTRICTION_TYPE_NONE;
  value: number | undefined;
};

// these channels are unsupported because currently we can't reliably map rateshop data onto Channel Manager data for these channels
export const UNSUPPORTED_CLOSING_THE_LOOP_CHANNELS: OtaId[] = [
  OTA_IDS.BRANDDOTCOM,
  OTA_IDS.HRS,
] as const;

export const PMS_TABLE_PRICE_CELL_MODES = {
  EDIT: 'EDIT',
  UNDO: 'UNDO',
  DEFAULT: 'DEFAULT',
} as const;
